import { Reducer } from "redux";
import {
  CLEAR_ALL,
  FETCH_FAILURE,
  FETCH_REQUEST,
  FETCH_SUCCESS,
} from "./actions";

export type FetchEntry = {
  loading: boolean;
  error: any | null;
  data: any | null;
};

export type FetchDataState = Record<string, FetchEntry>;

const initial: FetchDataState = {};

const reducer: Reducer<FetchDataState> = (state = initial, action) => {
  switch (action.type) {
    case FETCH_REQUEST: {
      const key = action.payload.key as string;
      return {
        ...state,
        [key]: { loading: true, error: null, data: state[key]?.data ?? null },
      };
    }
    case FETCH_SUCCESS: {
      const { key, data } = action.payload as { key: string; data: any };
      return { ...state, [key]: { loading: false, error: null, data } };
    }
    case FETCH_FAILURE: {
      const { key, error } = action.payload as { key: string; error: any };
      return { ...state, [key]: { loading: false, error, data: null } };
    }
    case CLEAR_ALL: {
      return initial;
    }
    default:
      return state;
  }
};

export default reducer;
